import { Component, Input } from '@angular/core';
import {AppAlertService, PopupService, SubtitlesService} from "../../core";
import {
  LanguageShortcut,
  DocumentType,
} from "../../models";

@Component({
  selector: 'popups-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PopupPolicyComponent {
  @Input() key: any;
  acceptPrivatePolicy: boolean = false;

  constructor(
      public subtitles: SubtitlesService,
      public appAlert: AppAlertService,
      public popup: PopupService,
  ) {}

  showDocumentPopup(language: LanguageShortcut, type: DocumentType): void {
    this.appAlert.showDocumentPopup(language, type);
  }

  confirmPolicy(key: any): void {
    this.popup.confirmPolicy(key);
  }

  protected readonly LanguageShortcut = LanguageShortcut;
}